/* THIS IS A GENERATED FILE, DO NOT EDIT MANUALLY! */
/* eslint-disable -- This is a generated file */

// import hooks
import useSwr from "../useGet.hook";

// import types
import type { AxiosRequestConfig, AxiosResponse } from "axios";
import type { SWRConfig } from "../useGet.hook";
import type { UserSettingsViewModel } from "../types";

/**
 * SWR hook useGetUserSettingsHook
 */
export const useGetUserSettingsHook = (
  axiosConfig?: AxiosRequestConfig,
  swrConfig?: SWRConfig<AxiosResponse<UserSettingsViewModel>>,
) =>
  useSwr<UserSettingsViewModel>(
    {
      url: `/api/settings/user`,
      method: "get",
      params: {},
      ...axiosConfig,
    },
    swrConfig,
  );

export default useGetUserSettingsHook;
